import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Categories from "./pages/Categories";
import CategoryDetail from "./pages/CategoryDetail";
import TaskDetail from "./pages/TaskDetail";
import Leaderboards from "./pages/Leaderboards";
import Perks from "./pages/Perks";
import Challenges from "./pages/Challenges";
import ChallengeDetail from "./pages/ChallengeDetail";
import Profile from "./pages/Profile";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Admin from "./pages/Admin";
import Org from "./pages/Org";
import Events from "./pages/Events";
import Sponsor, { SponsorSuccess } from "./pages/Sponsor";
import Partner from "./pages/Partner";

const ADMIN_ROLES = ["admin"];
const ORG_ROLES = ["admin", "org_manager"];
const PARTNER_ROLES = ["admin", "sponsor"];

function AppRouter() {
  const location = useLocation();
  // CRITICAL: handle Emergent Google OAuth callback fragment BEFORE any route renders
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/sponsor" element={<Sponsor />} />
      <Route path="/sponsor/success" element={<SponsorSuccess />} />

      <Route path="/onboarding" element={
        <ProtectedRoute><Onboarding /></ProtectedRoute>
      } />

      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/categories/:id" element={<CategoryDetail />} />
        <Route path="/tasks/:id" element={<TaskDetail />} />
        <Route path="/leaderboards" element={<Leaderboards />} />
        <Route path="/perks" element={<Perks />} />
        <Route path="/challenges" element={<Challenges />} />
        <Route path="/challenges/:id" element={<ChallengeDetail />} />
        <Route path="/events" element={<Events />} />
        <Route path="/profile" element={<Profile />} />
      </Route>

      <Route path="/admin" element={
        <ProtectedRoute requireRole={ADMIN_ROLES}><AppLayout /></ProtectedRoute>
      }>
        <Route index element={<Admin />} />
      </Route>

      <Route path="/org" element={
        <ProtectedRoute requireRole={ORG_ROLES}><AppLayout /></ProtectedRoute>
      }>
        <Route index element={<Org />} />
      </Route>

      <Route path="/partner" element={
        <ProtectedRoute requireRole={PARTNER_ROLES}><AppLayout /></ProtectedRoute>
      }>
        <Route index element={<Partner />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
